import axios from "axios";
import { buildSnoozePayload } from "./snoozeHelpers";

export function updateCreditSnooze(credit, mode, authHeader) {
  const stats = {
    ...(credit.stats || {}),
    ...buildSnoozePayload(mode),
  };

  Object.keys(stats).forEach((key) => {
    if (stats[key] === null || stats[key] === undefined) {
      delete stats[key];
    }
  });

  const saveData = {
    ...credit,
    stats,
  };

  return axios({
    url: `${process.env.REACT_APP_API_SERVICE_URL}/credits/${credit.id}`,
    method: "put",
    data: saveData,
    headers: authHeader,
  });
}

// POST/credits/{id}/snooze
export function snoozeCredit(creditId, mode, authHeader) {
  const snoozePayload = buildSnoozePayload(mode);

  return axios({
    url: `${process.env.REACT_APP_API_SERVICE_URL}/credits/${creditId}/snooze`,
    method: "post",
    data: snoozePayload,
    headers: authHeader,
  });
}

// POST/credits/{id}/unsnooze
export function unsnoozeCredit(creditId, authHeader) {
  return axios({
    url: `${process.env.REACT_APP_API_SERVICE_URL}/credits/${creditId}/unsnooze`,
    method: "post",
    headers: authHeader,
  });
}